<template>
  <div class="bdy">
    <div class="headbt">
      <span class="zjt" @click="fh"><img src="../../assets/img/zjt.png" ></span>测评详情&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>


    <div class="cpjg">
        <div class="cpjg_title">
           {{title}}测评
        </div>
        <div class="cpjg_detail">
          <div class="cpt">
               <img  src="../../assets/img/cpjgimg1.png"/>
          </div>
          <div class="bg-line">
            <div class="bgline-item">姓名：{{user.nickName}}</div>
            <div class="bgline-item">学校：{{user.deptName}}</div>
          </div>
          <div class="bg-line">
            <div class="bgline-item">班级：{{user.classesName}}</div>
            <div class="bgline-item">电话：{{user.phonenumber}}</div>
          </div>
          <div class="pjinfo">
            <div class="cp-title">【评价说明】</div>
            <div class="cp-value">{{cpfjinfo.explanation}}</div>
          </div>
          <div class="fenshu">{{cpfjinfo.totalScore}}</div>
          <div class="cp_title">【测评说明】</div>
          <div class="cp_content">
            {{cpfjinfo.explanation}}
          </div>
          <div class="cp_title" v-if="tabdata_count >0">【测评细则】</div>
          <div class="cp_xz" v-if="tabdata_count >0">
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
                >
                <el-table-column
                  prop="remarks"
                  label="心理状态"
                  align="center"
                  >
                </el-table-column>
                <el-table-column
                  prop="sumOptionValue"
                  label="分数"

                  align="center"
                  >
                </el-table-column>

              </el-table>
          </div>
          <div class="cpcp">
              <span class="cpcp_title">测评结果</span>
                {{cpfjinfo.evaluatingResult}}
          </div>
          <div class="cpcp">
              <span class="cpcp_title">总体评价</span>
               {{cpfjinfo.overallEvaluation}}
          </div>

          <div class="cpcp">
              <span class="cpcp_title">专家建议</span>
                {{cpfjinfo.expertAdvice}}
          </div>
        </div>
    </div>







   <!-- <div class="fixed-right" @click="tz('/user/kefu')">
     <img src="../../assets/img/zxzx.png" >
     <br>
     在线咨询
   </div> -->
   <div class="footer">
     <div class="item_list_menu col-sm-3 col-3 col-md-3"  @click="tz('/base/index')">
   	  <div class="dibumenu">
         	 <img src="../../assets/img/home.png" >
   	</div>
   	  <div class="xmtitle ">
   	  	首页
   	  </div>
     </div>
   	<div class="item_list_menu col-sm-3 col-3 col-md-3" @click="tz('/user/cprw')">
   		<div class="dibumenu">
         	<!-- <img src="../../static/wd.png" > -->
            <img src="../../assets/img/cp.png" >
   		</div>
   		<div class="xmtitle " >
   			测评任务
   		</div>
   	</div>
   	<div class="item_list_menu col-sm-3 col-3 col-md-3" @click="tz('/user/wdcp')">
   		<div class="dibumenu">
   		 	 <img src="../../assets/img/wdcp_xz.png" >
   		</div>
   		<div class="xmtitle xmtitle_active">
   			我的测评
   		</div>
   	</div>
   	<div class="item_list_menu col-sm-3 col-3 col-md-3" @click="tz('/user/index')">
   		<div class="dibumenu">
   			 <img src="../../assets/img/wd.png" >
   		</div>
   		<div class="xmtitle ">
   			我的
   		</div>
   	</div>
   </div>
   <div class="jbk">

   </div>

  </div>
</template>

<script>
import {ckcpjg} from '../../api/baseset'
  export default {
      data() {
        return {
              show_num:1,
              cpfjinfo:{},
              lbid:'',
              rwid:'',
              tableData:[],
              tabdata_count:0,
              title:'',
               user:{}
        }
      },
      mounted() {
        this.lbid = this.$route.params.id;
        this.rwid = this.$route.params.rwid;
        this.title = this.$route.params.title;
        this.getdata(this.lbid, this.rwid);
        let user_infos = JSON.parse(localStorage.getItem("user_infos"));

        this.user = user_infos
     // this.getsjtjs();
      },
      methods: {

        getdata(id,rwid){

          this.loading = true
          let parm={gaugeId:id,taskId:rwid}
            ckcpjg(parm)
             .then(res => {

               this.loading = false
               if (res.code != 200) {
                 this.$message({
                   type: 'info',
                   message: res.msg
                 })
               } else {

                  this.cpfjinfo = res.data;
                  this.tableData = res.data.evaluationDetailed
                  this.tabdata_count = this.tableData.length;

               }
             })
             .catch(err => {
               this.loading = false
               this.$message.error('数据加载失败，请稍后再试！')
             })

        },

        // 搜索事件
        search() {
          this.formInline.page = 1
          this.formInline.limit = 10
          this.getdata(this.formInline)
        },
        // 重置搜索
        formReset() {
          this.formInline.key = '';
        },
        shouli() {

        },
        chuli() {
          this.dialogVisible = true;
        },
        tz(url){

          this.$router.push(url);
        },
        fh(){
        // window.history.go(-1);
         this.$router.push("/user/wdcp");
        }
      }
    }
  </script>

<style scoped>
  	body{
  			background-color: white !important;
  		}
    .bdy{
      background-color: white !important;
    }
    .cpjg_title{
      width: 100%;
      height: 35px;
      line-height: 35px;
      text-align: center;
      margin-top: 15px;
    }
    .cpjg_detail{
          margin: 0 auto;
          padding-bottom: 50px;
          width: 95%;
          min-height: 500px !important;
          border: 10px solid #e9fafa;
          border-radius: 50px;
          position: relative;
          margin-top: 15px;
    }
    .cpt{
      width: 101px;
      height: 31px;
      margin: 0 auto;

      margin-top: -20px;
    }
    .cpt img{
      width: 100px;
      height: 32px;
    }
    .fenshu{

      width: 64px;
      height: 64px;
      margin: 0 auto;
       margin-top: 30px;
      border-radius: 50%;
      background-color: #00DDA3;
      line-height: 64px;
      text-align: center;
      color: white;

    }
    .cp_title{
      width: 90%;
      height: 35px;
      font-weight: bold;
      color: #00DDA3;
      font-size: 14px;
      margin: 0 auto;
      margin-top: 40px;
    }
    .cp_content{
      width: 90%;
      margin: 0 auto;
      margin-top: 1px;
      height: auto;
      font-size: 14px;
      color: #666666;
      padding-top: 1px;
      padding-bottom: 10px;
      line-height: 24px;

    }
    .cpcp{
      width: 90%;
      height: auto;
      margin: 0 auto;
      padding-top: 5px;
      padding-bottom: 5px;
      font-size: 14px;
       line-height: 24px;
        color: #666666;
      margin-top: 15px;
      display: block;
        /*  word-break: break-all; */
          word-wrap: break-word;
    }
    .cpcp_title{
      padding-top: 5px;
      padding-bottom: 5px;
      padding:5px 15px 5px 15px;
      background-color: #00DDA3;
      text-align: center;
      font-size: 14px;
      font-weight:bold;
      color: white;
    }
    .list-group-item{
    	border-radius: 0 0 0 0 ;
    	border: none !important;
    	padding:  0 0 0 0 !important;

    	height: 3rem;
    	line-height:3rem;
    	font-size: 14px;
    	color: #666666;
    	border-bottom: solid  1px #E6EAEC !important;
    }
    .list-group-item:first-child{
    	border-top-left-radius: 0;
    	border-top-right-radius: 0;

    }
    .item_list_menu{
    	/* border: solid 1px red; */
    	text-align: center;
    }
    .cp_xz{
      width: 95%;
      height: auto;
      margin:  0 auto;

      padding-top: 10px;
      padding-bottom: 10px;
    }
    .cp-title{color: #00DDA3;font-size: 14px;font-weight: bold;height: 50px;line-height: 50px;}
    .cp-value{line-height: 24px;font-size:13px;padding-left: 10px;padding-right: 10px;}
    .bg-line{display: flex;font-size: 13px;padding-left: 10px;padding-right: 10px;margin-top: 15px;color: #666666;}
    .bgline-item{width:50%;height: 40px;}
</style>



// WEBPACK FOOTER //
// src/views/user/wdcpdetail.vue